import { ConfluenceWorkspaceAri, IdentityUserAri } from '@atlassian/ari';

import {
	preloadSimplifiedNavForSpaceNav,
	type OnboardingStateResult,
} from '@confluence/experiment-simplify-nav-new-user/entry-points/preloadSimplifiedNavForSpaceNav.ts';
import { fg } from '@confluence/feature-gating';
import { preloadSideNavigationOnboardingState } from '@confluence/onboarding-helpers/entry-points/preloadSideNavigationOnboardingState.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

import { preloadGlobalApps } from './GlobalItems/AppsItem/preloadGlobalApps.ts';
import GlobalNavigationComponentQuery from './__generated__/GlobalNavigationComponentQuery.graphql.ts';
import type {
	GlobalNavigationComponentQuery$data,
	GlobalNavigationComponentQuery$variables,
} from './__generated__/GlobalNavigationComponentQuery.graphql.ts';

export const preloadGlobalNavigationComponent = async (spaceKey?: string) => {
	const { cloudId, userId, activationId, accessStatus } = getPreloaderFnContext();

	const promises: Promise<any>[] = [preloadGlobalApps()];

	if (userId) {
		promises.push(
			queryAgg<GlobalNavigationComponentQuery$data, GlobalNavigationComponentQuery$variables>({
				query: GlobalNavigationComponentQuery,
				context: {
					headers: {
						'Atl-Client-Name': 'confluence-frontend',
					},
				},
				variables: {
					entityAri: ConfluenceWorkspaceAri.create({ siteId: cloudId, activationId }).toString(),
					ownerAri: IdentityUserAri.create({ userId }).toString(),
				},
			}),
		);
	}

	if (
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS
	) {
		promises.push(
			preloadSideNavigationOnboardingState(
				// When FG on and on a space route: if user is simplify-nav D0-eligible, preload blog count for nav.
				spaceKey &&
					(fg('cc_activation_simplify_nav_preloader_enabled') ||
						fg('cfind_5565_creation_focused_nav_xflow_preload'))
					? (result) => preloadSimplifiedNavForSpaceNav(spaceKey, result as OnboardingStateResult)
					: undefined,
			),
		);
	}

	return waitForAllReturnWhenError(promises);
};
